<script>
import ClarificationForm from "@components/support-areas/internal-control/condusef/clarification-form.vue";

export default {
  name: "complaint-reports",
  components: {ClarificationForm}
}
</script>

<template>
  <div class="container mt-10">
    <span class="px-5 pill-danger pulse-danger">Sanbox</span>

    <vx-card title="Aclaraciones" class="mt-5">
      <clarification-form />
    </vx-card>
  </div>
</template>